import { motion } from "framer-motion";
import { Container, Title, Text } from "./styles";

const Greeting = () => (
  <Container>
    <motion.div
      initial="offscreen"
      animate="onscreen"
      variants={{
        offscreen: { opacity: 0, x: -50 },
        onscreen: { opacity: 1, x: 0 },
      }}
      transition={{ duration: 0.6 }}
      viewport={{ amount: 0.8 }}
    >
      <Title>About</Title>
      <Text>
        I'm Isaac Barcroft, a mobile-focused software engineer with 4+ years
        of experience building and shipping React Native applications in
        production. Based in Greenville, SC, I currently serve as VP of
        Engineering at a social fintech startup. When I'm not coding, you'll
        catch me on the soccer field or exploring ancient history.
      </Text>
      <Text>
        I specialize in React Native, Expo, TypeScript, and Node.js, with deep
        experience in mobile payments, serverless AWS infrastructure, and
        offline-first architectures. I'm passionate about shipping reliable
        mobile apps and mentoring the next generation of developers.
      </Text>
    </motion.div>
  </Container>
);
export default Greeting;
